export { Player as BannerPlayer } from './player';
export { VideoLesson as BannerVideoLesson } from './video-lesson';
